import React from 'react';
import { useLoader } from '@react-three/fiber';
import { TextureLoader } from 'three';
import { RigidBody } from '@react-three/rapier';

export default function Ground() {
  const aoMap = useLoader(TextureLoader, 'textures/coast_sand_rocks_02_ao_1k.jpg');
  const armMap = useLoader(TextureLoader, 'textures/coast_sand_rocks_02_arm_1k.jpg');
  const diffuseMap = useLoader(TextureLoader, 'textures/coast_sand_rocks_02_diff_1k.jpg');
  const displacementMap = useLoader(TextureLoader, 'textures/coast_sand_rocks_02_disp_1k.jpg');
  const normalMap = useLoader(TextureLoader, 'textures/coast_sand_rocks_02_nor_gl_1k.png');
  const roughnessMap = useLoader(TextureLoader, 'textures/coast_sand_rocks_02_rough_1k.jpg');

  return (
    <>
    <RigidBody type='fixed' colliders="trimesh">

    <mesh position={[0, -4.2, -39]} rotation-y={Math.PI} receiveShadow>
        <boxGeometry args={[30, 0.2, 86]} />
        <meshStandardMaterial
          aoMap={aoMap}
          aoMapIntensity={1}
          map={diffuseMap}
          displacementMap={displacementMap}
          displacementScale={0.2}
          normalMap={normalMap}
          roughnessMap={roughnessMap}
          metalnessMap={armMap}
        />
      </mesh>
      <mesh position={[0, -4.2, -114]} rotation-y={Math.PI} receiveShadow>
        <boxGeometry args={[30, 0.2, 57]} />
        <meshStandardMaterial
          aoMap={aoMap}
          aoMapIntensity={1}
          map={diffuseMap}
          displacementMap={displacementMap}
          displacementScale={0.2}
          normalMap={normalMap}
          roughnessMap={roughnessMap}
          metalnessMap={armMap}
        />
      </mesh>
      <mesh position={[0, -4.2, -175]} rotation-y={Math.PI} receiveShadow>
        <boxGeometry args={[30, 0.2, 57]} />
        <meshStandardMaterial
          aoMap={aoMap}
          aoMapIntensity={1}
          map={diffuseMap}
          displacementMap={displacementMap}
          displacementScale={0.2}
          normalMap={normalMap}
          roughnessMap={roughnessMap}
          metalnessMap={armMap}
        />
      </mesh>

      <mesh position={[0, -4.2, -238.2]} rotation-y={Math.PI} receiveShadow>
        <boxGeometry args={[30, 0.2, 57]} />
        <meshStandardMaterial
          aoMap={aoMap}
          aoMapIntensity={1}
          map={diffuseMap}
          displacementMap={displacementMap}
          displacementScale={0.2}
          normalMap={normalMap}
          roughnessMap={roughnessMap}
          metalnessMap={armMap}
        />
      </mesh>


    </RigidBody>
      
    </>
  );
}
